import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import {
    SANCTION_TYPE_PEP,
    SANCTION_TYPE_PEP_ES,
    SANCTION_TYPE_WATCHB,
    SANCTION_TYPE_SANLST,
    SANCTION_TYPE_ES_EMBARGOS,
    SANCTION_TYPE_ES_FRONTEIRA_INTERNATIONAL,
    SANCTION_TYPE_SANCTION_LISTS
} from './../../constants';

export default class AboutThisSource extends Component {

    static propTypes = {
        sanctionType: PropTypes.string
    };

    static defaultProps = {
        sanctionType: ''
    };

    render() {

        let component;
        switch(this.props.sanctionType) {
            case SANCTION_TYPE_PEP_ES:
            case SANCTION_TYPE_PEP:
                component = <div>
                                {/*Politically Exposed People*/}
                                <div className="about-this-source__info--rows">
                                    <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverage"/>: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverage.pepText'/>
                                </div>

                                {/*<div className="about-this-source__info--rows">*/}
                                    {/*<b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverageType" />: </b>*/}
                                    {/*<div>/People/People Directories &amp; Profiles</div>*/}
                                    {/*<div>/People/People Finder</div>*/}
                                    {/*<div>/Public Records/People Finder</div>*/}
                                {/*</div>*/}

                                <div className="about-this-source__info--rows">
                                    <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency.pepText'/>
                                </div>

                                <div className="about-this-source__info--rows">
                                    <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.updateSchedule" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.updateSchedule.pepText'/>
                                </div>

                                <div className="about-this-source__info--rows">
                                    <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.publisher" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.publisher.pepText'/>
                                </div>
                            </div>;
                break;
            case SANCTION_TYPE_WATCHB:
                component = <div>
                                {/*Watchlist and Blacklist*/}
                                <div className="about-this-source__info--rows">
                                    <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverage"/>: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverage.watchbText'/>
                                </div>

                                {/*<div className="about-this-source__info--rows">*/}
                                    {/*<b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverageType" />: </b>*/}
                                    {/*<div>/People/People Directories &amp; Profiles</div>*/}
                                    {/*<div>/People/People Finder</div>*/}
                                    {/*<div>/Public Records/People Finder</div>*/}
                                {/*</div>*/}

                                <div className="about-this-source__info--rows">
                                    <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency.watchbText'/>
                                </div>


                                <div className="about-this-source__info--rows">
                                    <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.updateSchedule" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.updateSchedule.watchbText'/>
                                </div>

                                <div className="about-this-source__info--rows">
                                    <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.publisher" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.publisher.watchbText'/>
                                </div>
                            </div>;
                break;
            case SANCTION_TYPE_SANLST:
                component = <div>
                                {/*SANLST*/}
                                <div className="about-this-source__info--rows">
                                    <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverage"/>: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverage.sanlstText'/>
                                </div>

                                {/*<div className="about-this-source__info--rows">*/}
                                    {/*<b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverageType" />: </b>*/}
                                    {/*<div>/People/People Directories &amp; Profiles</div>*/}
                                    {/*<div>/People/People Finder</div>*/}
                                    {/*<div>/Public Records/People Finder</div>*/}
                                {/*</div>*/}

                                <div className="about-this-source__info--rows">
                                    <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency.sanlstText'/>
                                    <div>Other Special Sanction Lists (Bush, FinCEN 311, FDFA) frequency is Weekly</div>
                                </div>

                                <div className="about-this-source__info--rows">
                                    <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.updateSchedule" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.updateSchedule.sanlstText'/>
                                </div>

                                <div className="about-this-source__info--rows">
                                    <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.publisher" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.publisher.sanlstText'/>
                                </div>
                            </div>;

                break;

            case SANCTION_TYPE_SANCTION_LISTS:
                component = <div>
                    {/*Sanction Lists*/}
                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverage"/>: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverage.sanctionListsText'/>
                    </div>

                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverageType" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverageType.sanctionListsText'/>
                    </div>

                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency.sanctionListsText1'/>
                        <div><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency.sanctionListsText2'/></div>
                    </div>

                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.updateSchedule" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.updateSchedule.sanctionListsText'/>
                    </div>

                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.publisher" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.publisher.sanctionListsText'/>
                    </div>

                    <div className="about-this-source__info--rows">
                        <span className="all-caps"><b><FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.tableHeader.language" />: </b></span><span>English</span>
                    </div>
                </div>;

                break;

            case SANCTION_TYPE_ES_EMBARGOS:
                component = <div>
                    {/*Autuações Ambientais e Embargos*/}
                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverage"/>: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverage.embargosText'/>
                    </div>

                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverageType" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverageType.embargosText'/>
                    </div>

                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency.embargosText'/>
                    </div>

                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.updateSchedule" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.updateSchedule.embargosText'/>
                    </div>

                    <div className="about-this-source__info--rows">
                        <span className="all-caps"><b><FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.tableHeader.language" />: </b></span><span>Portuguese</span>
                    </div>
                </div>;
                break;
            case SANCTION_TYPE_ES_FRONTEIRA_INTERNATIONAL:
                component = <div>
                    {/*Municípios que tocam a fronteira internacional*/}
                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverage"/>: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverage.fronteiraText'/>
                    </div>

                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverageType" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.coverageType.fronteiraText'/>
                    </div>

                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.frequency.fronteiraText'/>
                    </div>

                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.updateSchedule" />: </b><FormattedMessage id='Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.updateSchedule.fronteiraText'/>
                    </div>

                    <div className="about-this-source__info--rows">
                        <b><FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.tableHeader.language" />: </b><span>Portuguese</span>
                    </div>
                </div>;
                break;
            default:
                component = <div>{this.props.sanctionType}</div>;
                break;

        }

        return (

            <div className="content-summary__info">

                {component}

            </div>


        );

    };

}



// WEBPACK FOOTER //
// ./src/scripts/pages/SanctionReports/SanctionReports.SanctionType.AboutThisSource.jsx